import { newsletters } from '@markku/db'
import { createInsertSchema, createSelectSchema } from 'drizzle-zod'
import { z } from 'zod'
import { audienceFilterSchema } from './audienceFilter'

export const selectNewsletterSchema = createSelectSchema(newsletters)
export const insertNewsletterSchema = createInsertSchema(newsletters).omit({
  id: true,
  createdAt: true,
  updatedAt: true,
})

// Back-compat alias: newsletters referenced `newsletterAudienceFilterSchema`
// before the shared audience module was extracted.
export const newsletterAudienceFilterSchema = audienceFilterSchema

export const upsertNewsletterSchema = z.object({
  subject: z.string().min(1),
  designJson: z.any().optional(),
  html: z.string().optional(),
  audienceFilter: audienceFilterSchema.optional(),
})

export type Newsletter = z.infer<typeof selectNewsletterSchema>
export type InsertNewsletter = z.infer<typeof insertNewsletterSchema>
export type UpsertNewsletter = z.infer<typeof upsertNewsletterSchema>
export type NewsletterAudienceFilter = z.infer<typeof audienceFilterSchema>
